import maNavbarCategory from '@/components/navbarCategories'
import maSpinner from '@/components/spinner'
import maNavbarStepper from '@/components/navbarStepper'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiSearchMobilierUptec } from '@/modules/Damage/services/menus'
import debounce from '@/utils/debounce'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_CATEGORIES_QTY,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_LITERALS_MOBILIER,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE,
  WARRANTY_UPDATE_OBJ_UPTEC
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageMobilierUptecFeature',

  mixins: [flowMixin],

  components: {
    maNavbarCategory,
    maSpinner,
    maNavbarStepper
  },
  data: function () {
    return {
      listCategories: [],
      listNestedTitles: [],
      inputTxtSearch: '',
      searchIsActive: false,
      listCat: [],
      levels: {},
      searchNotFound: false,
      listItemsSearch: [],
      searchParams: {
        query: null,
        offset: 0,
        product_group_id: null
      },
      listUptecDom: null,
      totalPages: null,
      isloadingMoreItems: false,
      damageTypeToReturn: ''
    }
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyId: 'warrantyId',
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms',
      stateWarrantyTextInputSearchMobilier: 'textInputSearchMobilier',
      stateWarrantyKeysMobilier: 'keysMobilier',
      stateWarrantyCategoriesMobilier: 'categoriesMobilier',
      stateWarrantyCategoryFinalLevel: 'categoryFinalLevel',
      stateWarrantyDamagedPartKey: 'damagedPartKey'
    }),

    /**
     * Based on the route category processes and returns the title
     */
    titleCategory() {
      const category = this.getDamageType
      const title = category.replace('_', ' ').replace('_', ' ').toLowerCase()
      return title
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyUpdateCategoriesQty: WARRANTY_UPDATE_CATEGORIES_QTY,
      mutWarrantyUpdateLiteralsMobilier: WARRANTY_UPDATE_LITERALS_MOBILIER,
      mutWarrantyUpdateCategFinalLevel: WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
      mutWarrantyUpdateTextSearchMobilier: WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
      mutWarrantyUpdateDamagedItem: WARRANTY_UPDATE_DAMAGED_ITEM,
      mutWarrantyUpdateProductIdUptecFeature:
        WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE,
      mutWarrantyUpdateObjUptec: WARRANTY_UPDATE_OBJ_UPTEC
    }),

    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    handleClickPrevPage() {
      window.removeEventListener('popstate', this.handleClickPrevPage)
      const damageMobilierViewName = 'damageMobilier'
      const propertyType = this.getPropertyType
      let damageType = this.damageTypeToReturn
      this.goToView(damageMobilierViewName, { propertyType, damageType })
    },

    /**
     * When input text is cliecked it pushes the params for the damageSearchMobilierRoute
     */
    handleClickSearch() {
      const damageMobilierSearchUptecViewName = 'damageMobilierSearchUptec'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      const productId = this.getProductId
      this.goToView(damageMobilierSearchUptecViewName, {
        propertyType,
        damageType,
        productId
      })
    },

    /**
     * Returns the filtered form, removing the assets and hidden input
     */
    filteredForm(form) {
      let formResult = {}
      form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
        (input) => {
          return input.name !== 'ASSETS'
        }
      )

      // remove hidden inputs
      form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
        (input) => {
          return input.type !== 'hidden'
        }
      )
      formResult = form.form.regions[0].inputs[0]
      return formResult
    },

    goToNextRoute() {
      const damageMobilierCategory3ViewName = 'damageMobilierCategory3'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierCategory3ViewName, {
        propertyType,
        damageType
      })
    },

    /**
     * When input text is filled, if the input text has more than 3 letters it will send the text to the search mobilier api and get back the response or if it's empty an empty will be printed
     */
    handleChangeInputTxt: debounce(function () {
      this.listItemsSearch = []
      this.searchNotFound = false

      if (this.inputTxtSearch.length >= 1) {
        this.searchIsActive = true
        this.searchParams.query = this.inputTxtSearch
        this.searchParams.product_group_id = this.$route.params.productId

        apiSearchMobilierUptec(this.searchParams).then((result) => {
          if (result.results.length > 0) {
            this.listItemsSearch = [...this.listItemsSearch, ...result.results]
            this.totalPages = result.total_pages
            this.$nextTick(() => {
              this.listUptecDom = this.$refs.listItemsUptec
              this.listUptecDom.addEventListener('scroll', this.handleScroll)
              this.highlightSearch()
            })
          } else {
            this.searchNotFound = true
          }
        })
          .catch((error) => {
            const context = {
              component: 'damageMobilierUptecFeature',
              method: 'handleChangeInputTxt',
              route: this.$route.path
            }

            const tags = prepareErrorForSentry(error, context)

            this.sendSentryError(
              `Error searching mobilier products: ${error.message || 'Unknown error'}`,
              error.response && error.response.status >= 500 ? 'error' : 'warning',
              tags,
              this.getWarrantyId,
              'handleChangeInputTxt'
            )
          })
      } else {
        this.searchIsActive = false
        this.listItemsSearch = []
      }
    }, 500),

    handleScroll() {
      const heightList = this.listUptecDom.scrollHeight
      const visiblePartList = this.listUptecDom.clientHeight
      if (
        visiblePartList + this.listUptecDom.scrollTop === heightList &&
        this.searchParams.offset < this.totalPages
      ) {
        this.searchParams.offset += 1
        this.isloadingMoreItems = true
        apiSearchMobilierUptec(this.searchParams)
          .then((result) => {
            this.listItemsSearch = [...this.listItemsSearch, ...result.results]
            this.totalPages = result.total_pages
            this.$nextTick(() => {
              this.highlightSearch()
            })
          })
          .catch((error) => {
            const context = {
              component: 'damageMobilierUptecFeature',
              method: 'handleScroll',
              route: this.$route.path
            }

            const tags = prepareErrorForSentry(error, context)

            this.sendSentryError(
              `Error loading more search results: ${error.message || 'Unknown error'}`,
              error.response && error.response.status >= 500 ? 'error' : 'warning',
              tags,
              this.getWarrantyId,
              'handleScroll'
            )
          })
          .finally(() => {
            this.isloadingMoreItems = false
          })
      }
    },

    /**
     * Adds the report proerties to get the form
     */
    addReportProperties() {
      let key = 'propertyType'
      let value = this.getPropertyType
      this.mutWarrantyUpdateReport({ key, value })
      key = 'ASSETS'
      value = this.getDamageType
      this.mutWarrantyUpdateReport({ key, value })
    },

    /**
     * Gets the form data to print the categories
     */
    getForm() {
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.addReportProperties()
      const warrantyId = this.getWarrantyId
      const report = this.stateWarrantyReport
      this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
        if (resp.formsUpdated) {
          this.listCategories =
            this.stateWarrantyForms[0].form.regions[0].inputs[2]
        }
      })
    },

    /**
     * When the search is active, it will update the literals of the clicked item
     */
    handleClickCategExtraDetails(literal1, literal2, literal3) {
      let category
      let literal
      this.mutWarrantyUpdateCategoriesQty(0)
      this.mutWarrantyUpdateCategFinalLevel(true)
      if (literal1 && literal2 && literal3) {
        category = 'cat1'
        literal = literal1
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
        category = 'cat2'
        literal = literal2
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
        category = 'cat3'
        literal = literal3
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
      } else if (literal1 && literal2) {
        category = 'cat1'
        literal = literal1
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
        category = 'cat2'
        literal = literal2
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
      } else if (literal1) {
        category = 'cat1'
        literal = literal1
        this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
      }
    },

    handleClickCategorySearch(productd, imgSmallUrl) {
      window.removeEventListener('popstate', this.handleClickPrevPage)
      this.mutWarrantyUpdateCategFinalLevel(true)
      let key = 'imageFeature'
      let value = imgSmallUrl
      this.mutWarrantyUpdateObjUptec({ key, value })
      this.mutWarrantyUpdateProductIdUptecFeature(productd)
      this.goToNextRoute()
    },

    /**
     * Highlight the search input text in the text result
     */
    highlightSearch() {
      var text = document.getElementById('search_text').value
      var searchResults = document.querySelectorAll('.searchText')
      searchResults.forEach((result) => {
        result.innerHTML = result.innerHTML.replace(
          new RegExp('(' + text + ')', 'ig'),
          '<span class=highlight>$1</span>'
        )
      })
    }
  },

  /**
   * Clears the mobilier properties; if there is text input search mobilier it will update the input text value and execute the handler that searches; executes get form
   */
  mounted() {
    this.damageTypeToReturn = this.getDamageType
    window.addEventListener('popstate', this.handleClickPrevPage)
    if (this.stateWarrantyTextInputSearchMobilier) {
      this.inputTxtValue = this.stateWarrantyTextInputSearchMobilier
      this.handleChangeInputTxt()
    }
  },

  /**
   * Clears the input text value and the state search mobilier input text
   */
  beforeDestroy: function () {
    this.inputTxtValue = ''
    this.mutWarrantyUpdateTextSearchMobilier('')
  }
}
